<template>
  <div>
    <Modal
      ref="modal"
      title="Message Team"
      body="Warning, this will send a message to your whole team. Use carefully. Bulk messaging must be enabled for your account before being able to send to ensure compliance with wireless network regulations. Please email support@humaniz.io to get registered. Registration usually takes 2-5 business days."
      action="Send"
      action-color="indigo"
      @close-modal="handleCancel"
      @handle-action="handleSend"
    >
      <div class="mx-auto mb-4">
        <div class="mt-6 sm:mt-5 sm:pt-5">
          <div class="mt-1 sm:mt-0">
            <div class="w-full">
              <TextareaMergeTagInput
                ref="messageInput"
                label="Message Body"
                placeholder="Enter your message..."
                :model-value="message"
                @update:model-value="message = $event"
              />
            </div>
          </div>
        </div>
        <div class="mt-4 grid grid-cols-2 gap-3">
          <MergeTagSelect @selected-tag="tag => $refs.messageInput.insertMergeTagAtCursor(tag)" />
          <SelectMenu
            ref="smsTemplateselectMenu"
            label="Use existing template"
            :initial-value="smsTemplates.find(t => t.id === selectedTemplateId) || 'Select an SMS template...'"
            :options="smsTemplates.map(t => t.name)"
            @selected-option="template => setSmsTemplate(template)"
          />
        </div>
        <div class="mt-4 bg-gray-100 rounded p-6 text-sm flex justify-between">
          <div class="mt-2 text-sm leading-5 text-gray-900">Looking to create more SMS templates?</div>
          <router-link to="/settings/templates/sms" target="_blank">
            <TButton label="Template Library" color="white" />
          </router-link>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import TextAreaInput from '../shared/TextAreaInput.vue';
import MergeTagSelect from '@/components/shared/merge_tag/MergeTagSelect/index.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import TextareaMergeTagInput from '../shared/merge_tag/textarea_input/TextareaMergeTagInput.vue';

export default {
  components: {
    Modal,
    TextAreaInput,
    MergeTagSelect,
    TextareaMergeTagInput,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      message: '',
      selectedTemplateId: '',
      smsTemplates: [],
      selectedTab: 'Merge Tags',
    };
  },
  mounted() {
    this.getSmsTemplates();
  },
  methods: {
    handleSend() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch(`/api/team/message`, {
        method: 'POST',
        body: JSON.stringify({
          content: self.message,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            this.$emit('handleMessageTeam');
            toast.success('Team message sent', {
              action: { label: 'Dismiss' },
              description: 'Your team was successfully messaged.  Use the button below to dismiss this alert.',
            });
          } else {
            toast.error('Team message error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
    getSmsTemplates() {
      const self = this;
      fetch(`/api/sms_templates`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          self.smsTemplates = data.records;
        });
    },
    setSmsTemplate(templateName) {
      const self = this;
      const selectedTemplate = self.smsTemplates.find(t => t.name === templateName);
      if (selectedTemplate && selectedTemplate.body) {
        self.message = selectedTemplate.body;
        self.selectedTemplateId = selectedTemplate.id;
        this.$refs.messageInput.setContent(selectedTemplate.body);
      }
    },
    handleCancel() {
      this.$emit('handleMessageTeamCancel');
    },
  },
};
</script>
